"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["type", "onClick", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledButton = _styledComponents.default.button.withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-wnsik6-0"
})(["background-color:#fff;color:#77899e;display:inline-flex;align-items:center;justify-content:center;padding:6px 10px 7px;border-radius:4px;font-weight:500;font-size:1.4rem;letter-spacing:0.1px;line-height:1;outline:0;cursor:pointer;transition:color 0.3s ease,background-color 0.3s ease,border-color 0.3s ease;border:", ";"], function (props) {
  return props.btnLink ? 'none' : '2px solid #77899e';
});

var Button = function Button(_ref) {
  var type = _ref.type,
      onClick = _ref.onClick,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleClick = function handleClick(event) {
    event.preventDefault();
    onClick && onClick(event);
  };

  return /*#__PURE__*/_react.default.createElement(StyledButton, _extends({
    type: type || 'button'
  }, props, {
    onClick: handleClick
  }), children);
};

Button.propTypes = {
  onClick: _propTypes.default.func.isRequired
};
var _default = Button;
exports.default = _default;